/**
 * content — index redirect (brief §content). `/library` itself has no page
 * of its own: it sends the student straight to the topic browser. Kept as
 * `Page.tsx` per `docs/CONVENTIONS.md`'s file map ("replace the placeholder")
 * rather than deleted; `TopicsPage.tsx`, `FormulasPage.tsx` and
 * `ExamsPage.tsx` are the three real pages `index.ts` mounts as its children
 * (see `index.ts` for why there is one top-level path, `/library`, with
 * three children rather than three top-level routes).
 */
import { Navigate } from "react-router";

export function ContentPage() {
  return <Navigate to="/library/topics" replace />;
}

export default ContentPage;

/** `/library/archive` was linked from nowhere but guessed often; the old exams live at `/library/exams`. */
export function ArchiveRedirect() {
  return <Navigate to="/library/exams" replace />;
}
